(function () {
  'use strict';

  var $ = function(sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); };

  var root = $('.ep02');
  if (!root) return;

  var PREFIJO_SKU = root.dataset.prefijoSku || 'EP_02';
  var WA_NUMERO = root.dataset.whatsappNumero;
  var PRODUCT_TITLE = $('.ep02__titulo').textContent.trim();

  var state = {
    variantes: [],
    seleccion: {
      alto: null,
      ancho: null,
      fondo: null,
      niveles: null,
      ensamble: 'Soldada',
      tendido: 'No',
      'modulo-adicional': 'No'
    },
    cantidad: 1
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    state.variantes = window.EP02_VARIANTES || [];
    bindEventos();
    seleccionPorDefecto();
    actualizar();
  }

  function buscarVariante(ref) {
    for (var i = 0; i < state.variantes.length; i++) {
      if (state.variantes[i].sku === ref) {
        return state.variantes[i];
      }
    }
    return null;
  }

  function getPrecio(variante) {
    var p = variante.price;
    if (typeof p === 'string') p = parseFloat(p);
    return p / 100;
  }

  function bindEventos() {
    root.addEventListener('click', function(e) {
      var pill = e.target.closest('.ep02__pill');
      if (pill && !pill.classList.contains('is-disabled')) {
        var dim = pill.dataset.dim;
        var valor = pill.dataset.valor;
        if (['alto', 'ancho', 'fondo', 'niveles'].indexOf(dim) !== -1) {
          state.seleccion[dim] = parseInt(valor, 10);
        } else {
          state.seleccion[dim] = valor;
        }
        actualizar();
      }
    });

    $$('.ep02__cantidad-btn').forEach(function(b) {
      b.addEventListener('click', function(e) {
        var input = $('#ep02-cantidad');
        var v = parseInt(input.value, 10) || 1;
        v += (e.target.dataset.action === 'mas' ? 1 : -1);
        v = Math.max(1, Math.min(99, v));
        input.value = v;
        state.cantidad = v;
        actualizar();
      });
    });

    var inputCant = $('#ep02-cantidad');
    if (inputCant) {
      inputCant.addEventListener('change', function(e) {
        state.cantidad = Math.max(1, parseInt(e.target.value, 10) || 1);
        e.target.value = state.cantidad;
        actualizar();
      });
    }

    $$('.ep02__thumb').forEach(function(t) {
      t.addEventListener('click', function() {
        $$('.ep02__thumb').forEach(function(x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        $('#ep02-render').src = t.dataset.image;
      });
    });

    var btnComprar = $('#ep02-comprar');
    if (btnComprar) btnComprar.addEventListener('click', onComprarClick);
    var btnAsesor = $('#ep02-asesor');
    if (btnAsesor) btnAsesor.addEventListener('click', onAsesorClick);
  }

  function seleccionPorDefecto() {
    state.seleccion.alto = 300;
    state.seleccion.ancho = 240;
    state.seleccion.fondo = 100;
    state.seleccion.niveles = 3;
    state.seleccion.ensamble = 'Soldada';
    state.seleccion.tendido = 'No';
    state.seleccion['modulo-adicional'] = 'No';
    console.log('[MAIKO EP-02] Selección por defecto: 300/240/100/3 | Tendido: No (Para Estibas) | Módulo adicional: No');
  }

  function actualizar() {
    // Sincronizar pills visuales con el estado
    ['alto', 'ancho', 'fondo', 'niveles', 'ensamble', 'tendido', 'modulo-adicional'].forEach(function(dim) {
      $$('.ep02__pill[data-dim="' + dim + '"]').forEach(function(p) {
        var valor = p.dataset.valor;
        var esNumerico = ['alto', 'ancho', 'fondo', 'niveles'].indexOf(dim) !== -1;
        var match = esNumerico ? parseInt(valor, 10) === state.seleccion[dim] : valor === state.seleccion[dim];
        p.classList.toggle('is-active', match);
      });
    });

    var ref = construirRef();
    var refEl = $('#ep02-ref');
    if (refEl) refEl.textContent = ref;

    // Si módulo adicional = Sí → SIEMPRE cotización
    if (state.seleccion['modulo-adicional'] === 'Si') {
      modoCotizarModulo();
    // Si tendido = Sí → SIEMPRE cotización (tendido se cotiza a medida)
    } else if (state.seleccion.tendido === 'Si') {
      modoCotizarTendido();
    } else {
      var variante = buscarVariante(ref);
      if (variante) {
        modoComprar(variante);
      } else {
        modoCotizar();
      }
    }

    actualizarCargaTotal();
    cambiarImagenPorNiveles(state.seleccion.niveles);
  }

  function cambiarImagenPorNiveles(niveles) {
    var container = document.getElementById('ep02-niveles-images');
    if (!container) return;
    var renderEl = document.getElementById('ep02-render');
    // Tendido No = Para Estibas → buscar imágenes con -estibas
    // Tendido Si = con tendido → buscar imágenes normales
    var esEstibas = state.seleccion.tendido === 'No';

    var targetAlt = esEstibas ? 'niveles-' + niveles + '-estibas' : 'niveles-' + niveles;
    var imgExacto = container.querySelector('img[data-niveles="' + targetAlt + '"]');
    if (imgExacto) {
      renderEl.src = imgExacto.src;
      return;
    }

    if (esEstibas) {
      var imgNormal = container.querySelector('img[data-niveles="niveles-' + niveles + '"]');
      if (imgNormal) {
        renderEl.src = imgNormal.src;
        return;
      }
    }

    var todasImagenes = container.querySelectorAll('img[data-niveles]');
    for (var j = 0; j < todasImagenes.length; j++) {
      var alt = todasImagenes[j].getAttribute('data-niveles');
      if (alt && alt.indexOf('niveles-' + niveles) === 0) {
        renderEl.src = todasImagenes[j].src;
        return;
      }
    }

    var primera = container.querySelector('img[data-niveles]');
    if (primera) renderEl.src = primera.src;
  }

  function construirRef() {
    var s = state.seleccion;
    var base = PREFIJO_SKU + '_' + s.alto + '_' + s.ancho + '_' + s.fondo + '_' + s.niveles;
    // Tendido No = Para Estibas (niveles sin tendido) → tiene precio en variantes
    // Tendido Si = con tendido → cotización
    if (s.tendido === 'No') {
      base = base + '_Para_Estibas';
    }
    return base;
  }

  function actualizarCargaTotal() {
    var cargaEl = $('#ep02-carga-nivel');
    var totalEl = $('#ep02-carga-total');
    if (!cargaEl || !totalEl) return;
    var cargaPorNivel = parseInt(cargaEl.textContent, 10) || 0;
    if (cargaPorNivel > 0) {
      totalEl.textContent = (cargaPorNivel * state.seleccion.niveles) + ' kg';
    }
  }

  function modoComprar(variante) {
    var precio = getPrecio(variante);
    var total = precio * state.cantidad;
    var precioEl = $('#ep02-precio');
    if (precioEl) {
      precioEl.textContent = formatearPrecio(total);
      precioEl.classList.remove('is-cotizar');
    }
    var iva = $('.ep02__precio-iva');
    if (iva) iva.style.display = '';
    var msg = $('#ep02-mensaje-cotizar');
    if (msg) msg.hidden = true;
    var cantWrap = $('#ep02-cantidad-wrapper');
    if (cantWrap) cantWrap.hidden = false;
    var compTexto = $('#ep02-comprar-texto');
    if (compTexto) compTexto.textContent = compTexto.getAttribute('data-default') || 'Comprar';
    var btn = $('#ep02-comprar');
    if (btn) {
      btn.classList.remove('ep02__btn--cotizar');
      btn.disabled = false;
    }
  }

  function modoCotizar() {
    var precioEl = $('#ep02-precio');
    if (precioEl) {
      precioEl.textContent = 'Cotización personalizada';
      precioEl.classList.add('is-cotizar');
    }
    var iva = $('.ep02__precio-iva');
    if (iva) iva.style.display = 'none';
    var msg = $('#ep02-mensaje-cotizar');
    if (msg) msg.hidden = false;
    var cantWrap = $('#ep02-cantidad-wrapper');
    if (cantWrap) cantWrap.hidden = true;
    var compTexto = $('#ep02-comprar-texto');
    if (compTexto) compTexto.textContent = 'Solicitar cotización';
    var btn = $('#ep02-comprar');
    if (btn) {
      btn.classList.add('ep02__btn--cotizar');
      btn.disabled = false;
    }
  }

  // Modo cotización forzado por módulo adicional
  function modoCotizarModulo() {
    var precioEl = $('#ep02-precio');
    if (precioEl) {
      precioEl.textContent = 'Requiere cotización';
      precioEl.classList.add('is-cotizar');
    }
    var iva = $('.ep02__precio-iva');
    if (iva) iva.style.display = 'none';
    var msg = $('#ep02-mensaje-cotizar');
    if (msg) {
      msg.hidden = false;
      msg.querySelector('strong').textContent = 'Módulo adicional requiere cotización';
      msg.querySelector('p').textContent = 'Al incluir módulo adicional, esta configuración se cotiza a medida. Te enviamos la cotización por WhatsApp en menos de 24 horas hábiles.';
    }
    var cantWrap = $('#ep02-cantidad-wrapper');
    if (cantWrap) cantWrap.hidden = true;
    var compTexto = $('#ep02-comprar-texto');
    if (compTexto) compTexto.textContent = 'Solicitar cotización';
    var btn = $('#ep02-comprar');
    if (btn) {
      btn.classList.add('ep02__btn--cotizar');
      btn.disabled = false;
    }
  }

  // Modo cotización forzado por tendido
  function modoCotizarTendido() {
    var precioEl = $('#ep02-precio');
    if (precioEl) {
      precioEl.textContent = 'Requiere cotización';
      precioEl.classList.add('is-cotizar');
    }
    var iva = $('.ep02__precio-iva');
    if (iva) iva.style.display = 'none';
    var msg = $('#ep02-mensaje-cotizar');
    if (msg) {
      msg.hidden = false;
      msg.querySelector('strong').textContent = 'Tendido requiere cotización';
      msg.querySelector('p').textContent = 'Al incluir tendido, esta configuración se cotiza a medida. Te enviamos la cotización por WhatsApp en menos de 24 horas hábiles.';
    }
    var cantWrap = $('#ep02-cantidad-wrapper');
    if (cantWrap) cantWrap.hidden = true;
    var compTexto = $('#ep02-comprar-texto');
    if (compTexto) compTexto.textContent = 'Solicitar cotización';
    var btn = $('#ep02-comprar');
    if (btn) {
      btn.classList.add('ep02__btn--cotizar');
      btn.disabled = false;
    }
  }

  function onComprarClick() {
    var ref = construirRef();

    // Si módulo adicional = Sí → siempre WhatsApp cotización
    if (state.seleccion['modulo-adicional'] === 'Si') {
      abrirWhatsApp(ref, 'modulo-adicional');
      return;
    }

    // Si tendido = Sí → siempre WhatsApp cotización
    if (state.seleccion.tendido === 'Si') {
      abrirWhatsApp(ref, 'tendido');
      return;
    }

    var variante = buscarVariante(ref);
    if (variante) {
      agregarAlCarrito(ref, variante);
    } else {
      abrirWhatsApp(ref, 'cotizacion');
    }
  }

  function onAsesorClick() {
    abrirWhatsApp(construirRef(), 'asesor');
  }

  function agregarAlCarrito(ref, variante) {
    var btn = $('#ep02-comprar');
    var compTexto = $('#ep02-comprar-texto');
    var textoOriginal = compTexto ? compTexto.textContent : 'Comprar';
    if (btn) btn.disabled = true;
    if (compTexto) compTexto.textContent = 'Agregando...';
    var s = state.seleccion;
    var properties = {
      'Alto': s.alto + ' cm',
      'Ancho': s.ancho + ' cm',
      'Profundidad': s.fondo + ' cm',
      'Niveles': s.niveles,
      'Tipo de ensamble': s.ensamble,
      'Tendido': s.tendido === 'Si' ? 'Sí' : 'No',
      'Módulo adicional': 'No'
    };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variante.id, quantity: state.cantidad, properties: properties }]
      })
    })
    .then(function(resp) {
      if (!resp.ok) throw new Error('Error');
      window.location.href = '/cart';
    })
    .catch(function() {
      alert('No pudimos agregar el producto al carrito. Por favor intenta de nuevo o contáctanos por WhatsApp.');
      if (btn) btn.disabled = false;
      if (compTexto) compTexto.textContent = textoOriginal;
    });
  }

  function abrirWhatsApp(ref, tipo) {
    var s = state.seleccion;
    var tendidoLabel = s.tendido === 'Si' ? 'Sí' : 'No';
    var moduloLabel = s['modulo-adicional'] === 'Si' ? 'Sí' : 'No';
    var variante = buscarVariante(ref);
    var mensaje;

    if (tipo === 'modulo-adicional') {
      mensaje = 'Hola Maiko, quiero cotizar una estantería pesada EP-02 con módulo adicional:\n\n' +
                'Producto: ' + PRODUCT_TITLE + '\n' +
                'Referencia base: ' + ref + '\n' +
                'Alto: ' + s.alto + ' cm\n' +
                'Ancho: ' + s.ancho + ' cm\n' +
                'Profundidad: ' + s.fondo + ' cm\n' +
                'Niveles: ' + s.niveles + '\n' +
                'Tipo de ensamble: ' + s.ensamble + '\n' +
                'Tendido: Sí\n' +
                'Módulo adicional: Sí\n\n' +
                'Quedo atento a la cotización, gracias.';
    } else if (tipo === 'tendido') {
      mensaje = 'Hola Maiko, quiero cotizar una estantería pesada EP-02 con tendido:\n\n' +
                'Producto: ' + PRODUCT_TITLE + '\n' +
                'Referencia base: ' + ref + '\n' +
                'Alto: ' + s.alto + ' cm\n' +
                'Ancho: ' + s.ancho + ' cm\n' +
                'Profundidad: ' + s.fondo + ' cm\n' +
                'Niveles: ' + s.niveles + '\n' +
                'Tipo de ensamble: ' + s.ensamble + '\n' +
                'Tendido: Sí\n' +
                'Módulo adicional: ' + moduloLabel + '\n\n' +
                'Quedo atento a la cotización, gracias.';
    } else if (tipo === 'cotizacion') {
      mensaje = 'Hola Maiko, quiero cotizar una estantería pesada EP-02:\n\n' +
                'Producto: ' + PRODUCT_TITLE + '\n' +
                'Referencia: ' + ref + '\n' +
                'Alto: ' + s.alto + ' cm\n' +
                'Ancho: ' + s.ancho + ' cm\n' +
                'Profundidad: ' + s.fondo + ' cm\n' +
                'Niveles: ' + s.niveles + '\n' +
                'Tipo de ensamble: ' + s.ensamble + '\n' +
                'Tendido: ' + tendidoLabel + '\n' +
                'Módulo adicional: ' + moduloLabel + '\n\n' +
                'Quedo atento a la cotización, gracias.';
    } else {
      var precioInfo = variante ?
        '\nPrecio web: ' + formatearPrecio(getPrecio(variante)) :
        '\nCotización: personalizada';
      mensaje = 'Hola Maiko, quiero hablar con un asesor sobre:\n\n' +
                'Producto: ' + PRODUCT_TITLE + '\n' +
                'Referencia: ' + ref + '\n' +
                s.alto + 'x' + s.ancho + 'x' + s.fondo + ' cm - ' + s.niveles + ' niveles\n' +
                'Ensamble: ' + s.ensamble + '\n' +
                'Tendido: ' + tendidoLabel + '\n' +
                'Módulo adicional: ' + moduloLabel + precioInfo;
    }
    window.open('https://wa.me/' + WA_NUMERO + '?text=' + encodeURIComponent(mensaje), '_blank', 'noopener');
  }

  function formatearPrecio(valor) {
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(valor);
  }

})();
